// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#usergrouplist #addgroup[data-v-1c7fe5d6] .app-navigation-entry__utils{display:none}\n", ""]);
// Exports
module.exports = exports;
